import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import {
  FaGithubSquare,
  FaFacebookSquare,
  FaYoutubeSquare,
  FaLinkedin,
} from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import { SiMedium } from "react-icons/si";

interface Props {
  menuIsOpen: boolean;
  toggleMenu: () => void;
}

export const MenuOverlay: React.FC<Props> = ({ menuIsOpen, toggleMenu }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <Container menuIsOpen={menuIsOpen}>
      <Trapezoid menuIsOpen={menuIsOpen} windowWidth={windowWidth}>
        <Name>Watcharapol </Name>
        <Topic>About me</Topic>
        <Topic>Skills</Topic>
        <Topic>Experiences</Topic>
        <Topic>Projects</Topic>
        <Topic>Education</Topic>
        <Topic>Contact</Topic>
        <Icon>
          <a href="https://github.com/watcharapol28">
            <FaGithubSquare size={40} color="white " />
          </a>
          <a href="https://www.linkedin.com/in/watcharapol-treesatthayasakul-466743262/">
            <FaLinkedin size={40} color="white" />
          </a>
          <a href="https://medium.com/@treesatthayasakul.w">
            <SiMedium size={35} color="white" />
          </a>
          <a href="https://www.facebook.com/watcharapol.treesatthayasakul.96">
            <FaFacebookSquare size={40} color="white" />
          </a>
          <a href="https://www.instagram.com/wtxxd28/ ">
            <FaSquareInstagram size={40} color="white" />
          </a>
          <a href="https://www.youtube.com/">
            <FaYoutubeSquare size={40} color="white" />
          </a>
          <span>treesatthayasakul.w@gmail.com</span>
        </Icon>
      </Trapezoid>
    </Container>
  );
};

const Container = styled("div")<{ menuIsOpen: boolean }>(({ menuIsOpen }) => ({
  position: "fixed",
  visibility: menuIsOpen ? "visible" : "hidden",
  opacity: menuIsOpen ? 1 : 0,
  transition: "opacity 0.3s ease-in-out, visibility 0.5s ease-in-out",
  zIndex: "999",
}));

const Trapezoid = styled("div")<{ menuIsOpen: boolean; windowWidth: number }>(
  ({ menuIsOpen, windowWidth }) => ({
    paddingTop: "10vh",
    paddingLeft: (windowWidth * 1) / 10,
    transition: "transform 0.4s ease-in-out",
    transformOrigin: "top right",
    transform: menuIsOpen ? "rotate(0deg)" : "rotate(-180deg)",
    position: "fixed",
    listStyle: "none",
    right: 0,
    display: "table-row",
    width: (windowWidth * 3) / 10,
    height: "100vh",
    // background: "#ffb7b7",
    background: "linear-gradient(135deg,rgb(21, 8, 36),rgb(31, 18, 46))",
    clipPath: "polygon(0% 100%, 17.5% 0%, 100% 0%, 100% 100%)",
    "@media (max-width: 1440px)": {
      paddingLeft: (windowWidth * 3) / 20,
      width: (windowWidth * 4) / 10,
    },
    "@media (max-width: 1024px)": {
      clipPath: "polygon(0% 100%, 0% 0%, 100% 0%, 100% 100%)",
      width: "100%",
      left: "0",
      height: "100%",
      paddingLeft: 0,
    },
  })
);
const Topic = styled("li")({
  textDecoration: "none",
  position: "relative",
  marginTop: "20px",
  transition: "color 0.3s ease",
  fontSize: "30px",
  cursor: "pointer",

  "&:hover": {
    animation: "rainbow 2s infinite linear",
  },

  // Pointer arrow
  "&::before": {
    content: "'▶'",
    position: "absolute",
    left: "-35px",
    opacity: 0,
    fontSize: "22px",
    color: "#fff",
    transform: "translateX(0)",
  },

  "&:hover::before": {
    opacity: 1,
    animation:
      "pointerMove 1s infinite ease-in-out, rainbow 2s infinite linear",
  },

  "@keyframes pointerMove": {
    "0%": { transform: "translateX(0)" },
    "50%": { transform: "translateX(-5px)" }, // slide left
    "100%": { transform: "translateX(0)" },
  },

  "@keyframes rainbow": {
    // "0%": { color: "#fff" },
    "25%": { color: "#999" },
    "50%": { color: "#fff" },
    "75%": { color: "#999" },
    "100%": { color: "#fff" },
  },

  "@media (max-width: 1024px)": {
    paddingLeft: "10vw",
  },
});

const Name = styled("div")({
  fontSize: "50px",
  textAlign: "center",
});

const Icon = styled("div")({
  display: "flex",
  position: "absolute",
  bottom: "20vh",
  left: "7vw",

  gap: "10px",
  "& svg": {
    transition: "  0.3s ease",
  },
  "& svg:hover": {
    cursor: "pointer",
    fill: "black ",
  },
  "& a": {
    ":nth-of-type(3)": {
      marginTop: "3px",
    },
  },
  span: {
    marginLeft: "20px",
    alignContent: "center",
    fontFamily: "'Fira Code', monospace",
  },
});
